import ScheduleIcon from '@mui/icons-material/Schedule';
import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { FormattedRelativeTime } from 'react-intl';

interface CountdownProps {
  value: string | null | undefined;
}

/** Relative-time label for a future ISO datetime (e.g. scheduled publish). */
export function Countdown({ value }: CountdownProps) {
  const countdownHours = value && Math.round(DateTime.fromISO(value).diffNow('hours').hours);

  if (!countdownHours || countdownHours <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: '0.8rem',
        marginTop: 1,
        color: 'text.secondary',
      }}
    >
      <ScheduleIcon fontSize="inherit" />
      <Box
        component="span"
        sx={{
          '&::first-letter': {
            textTransform: 'uppercase',
          },
        }}
      >
        <FormattedRelativeTime
          value={countdownHours > 24 ? Math.round(countdownHours / 24) : countdownHours}
          unit={countdownHours > 24 ? 'day' : 'hour'}
          numeric="always"
          style="long"
        />
      </Box>
    </Box>
  );
}
